import { createSimpleCustomFieldsApi } from '..';
import { ItemType } from '../domain';
export * from './domains';
export * from './dto';
export * from './builder';
export var createCompaniesApi = function (baseUrl, http) {
    var url = baseUrl + "/companies";
    return {
        getAllCompanies: function () { return http.get("" + url); },
        getCompany: function (dto) { return http.get(url + "/" + dto.id); },
        deleteCompany: function (dto) { return http.delete(url + "/" + dto.id); },
        addCompany: function (dto) { return http.post("" + url, dto); },
        bulkAddCompanies: function (dto) { return http.post(url + "/bulk", dto); },
        updateCompany: function (dto) { return http.put(url + "/" + dto.id, dto); },
        search: function (dto) { return http.post(url + "/search/admin", dto); },
        customFields: createSimpleCustomFieldsApi("" + url, http, ItemType.COMPANY),
        updateCompanyCustomFields: function (dto) {
            return http.put(url + "/" + dto.id + "/fields", dto);
        },
        companyEmailDomainsCheck: function (dto) {
            return http.post(url + "/emailDomains/check", dto);
        },
    };
};
//# sourceMappingURL=index.js.map